import moment from "moment";
import { useCallback, useState, useEffect } from "react";

import { DateTimeConverter, DateTimeFormat } from "../lib/date-time-converter";

type DateTimeProps = {
  date: Date | moment.Moment;
  /**
   * LT  1:30 PM
   *
   * LTS 1:30:05 PM
   *
   * L 11/25/2021
   *
   * l    11/25/2021
   *
   * LL    November 25, 2021
   *
   * ll    Nov 25, 2021
   *
   * LLL   November 25, 2021 1:30 PM
   *
   * lll   Nov 25, 2021 1:30 PM
   *
   * LLLL  Thursday, November 25, 2021 1:30 PM
   *
   * llll  Thu, Nov 25, 2021 1:30 PM
   */
  format?: DateTimeFormat;
  customFormat?: string;
  fromNow?: boolean;
  calendar?: boolean;
  className?: string;
};

export const DateTime: React.FC<DateTimeProps> = ({
  fromNow,
  date: dateRaw,
  calendar,
  format,
  customFormat,
  className,
}) => {
  const getDate = useCallback(() => {
    if (fromNow === true) return DateTimeConverter.fromNow(dateRaw);
    if (calendar === true) return DateTimeConverter.calendar(dateRaw);

    return DateTimeConverter.format(dateRaw, format ?? customFormat);
  }, [calendar, customFormat, dateRaw, format, fromNow]);

  const [date, setDate] = useState(getDate());

  useEffect(() => {
    setDate(getDate());
  }, [getDate]);

  return (
    <span className={className} title={DateTimeConverter.format(dateRaw)}>
      {date}
    </span>
  );
};
